export const RBAC_LEVELS = ["VIEW", "INTERACT", "DELETE"] as const;

export type RbacLevel = (typeof RBAC_LEVELS)[number];

export interface RbacModuleDefinition {
  code: string;
  name: string;
  section: string;
  menuRoute: string;
  order: number;
  supportedLevels: readonly RbacLevel[];
}

export const RBAC_MODULE_CATALOG = [
  {
    order: 10,
    section: "Gestión legal",
    code: "dashboard",
    name: "Dashboard",
    menuRoute: "/dashboard",
    supportedLevels: ["VIEW"],
  },
  {
    order: 20,
    section: "Gestión legal",
    code: "clients",
    name: "Clientes",
    menuRoute: "/clients",
    supportedLevels: RBAC_LEVELS,
  },
  {
    order: 30,
    section: "Gestión legal",
    code: "matters",
    name: "Asuntos",
    menuRoute: "/matters",
    supportedLevels: RBAC_LEVELS,
  },
  {
    order: 40,
    section: "Gestión legal",
    code: "counterparties",
    name: "Contrapartes",
    menuRoute: "/counterparties",
    supportedLevels: RBAC_LEVELS,
  },
  {
    order: 50,
    section: "Gestión legal",
    code: "tasks",
    name: "Tareas",
    menuRoute: "/tasks",
    supportedLevels: RBAC_LEVELS,
  },
  {
    order: 60,
    section: "Documentos y firma",
    code: "documents",
    name: "Documentos",
    menuRoute: "/documents",
    supportedLevels: RBAC_LEVELS,
  },
  {
    order: 70,
    section: "Documentos y firma",
    code: "templates",
    name: "Plantillas",
    menuRoute: "/templates",
    supportedLevels: RBAC_LEVELS,
  },
  {
    order: 80,
    section: "Documentos y firma",
    code: "signature",
    name: "Firma",
    menuRoute: "/signature",
    supportedLevels: RBAC_LEVELS,
  },
  {
    order: 90,
    section: "Flujos",
    code: "workflow-inbox",
    name: "Bandeja de flujos",
    menuRoute: "/workflows/inbox",
    supportedLevels: RBAC_LEVELS,
  },
  {
    order: 100,
    section: "Flujos",
    code: "workflows",
    name: "Flujos",
    menuRoute: "/workflows",
    supportedLevels: RBAC_LEVELS,
  },
  {
    order: 110,
    section: "IA y conocimiento",
    code: "ai-assistant",
    name: "Asistente IA",
    menuRoute: "/ai",
    supportedLevels: RBAC_LEVELS,
  },
  {
    order: 120,
    section: "IA y conocimiento",
    code: "knowledge-base",
    name: "Base de conocimiento",
    menuRoute: "/rag",
    supportedLevels: RBAC_LEVELS,
  },
  {
    order: 130,
    section: "Control",
    code: "panels",
    name: "Paneles",
    menuRoute: "/dashboards",
    supportedLevels: ["VIEW"],
  },
  {
    order: 140,
    section: "Control",
    code: "reports",
    name: "Reportes",
    menuRoute: "/reports",
    supportedLevels: RBAC_LEVELS,
  },
  {
    order: 150,
    section: "Control",
    code: "risks",
    name: "Riesgos",
    menuRoute: "/risks",
    supportedLevels: RBAC_LEVELS,
  },
  {
    order: 160,
    section: "Comunicaciones",
    code: "notifications",
    name: "Notificaciones",
    menuRoute: "/notifications",
    supportedLevels: RBAC_LEVELS,
  },
  {
    order: 170,
    section: "Administración",
    code: "users-roles",
    name: "Usuarios y roles",
    menuRoute: "/admin/rbac",
    supportedLevels: RBAC_LEVELS,
  },
  {
    order: 180,
    section: "Administración",
    code: "organizations",
    name: "Organizaciones",
    menuRoute: "/admin/tenants",
    supportedLevels: RBAC_LEVELS,
  },
  {
    order: 190,
    section: "Administración",
    code: "matter-types",
    name: "Tipos de asunto",
    menuRoute: "/admin/matter-types",
    supportedLevels: RBAC_LEVELS,
  },
  {
    order: 200,
    section: "Administración",
    code: "risk-categories",
    name: "Categorías de riesgo",
    menuRoute: "/admin/risk-categories",
    supportedLevels: RBAC_LEVELS,
  },
  {
    order: 210,
    section: "Administración",
    code: "risk-scoring",
    name: "Scoring de riesgo",
    menuRoute: "/admin/scoring-policies",
    supportedLevels: RBAC_LEVELS,
  },
  {
    order: 220,
    section: "Administración",
    code: "matter-templates",
    name: "Plantillas de asunto",
    menuRoute: "/admin/matter-templates",
    supportedLevels: RBAC_LEVELS,
  },
  {
    order: 230,
    section: "Administración",
    code: "email-templates",
    name: "Plantillas email",
    menuRoute: "/admin/email-templates",
    supportedLevels: RBAC_LEVELS,
  },
  {
    order: 240,
    section: "Administración",
    code: "system-notifications",
    name: "Notificaciones sistema",
    menuRoute: "/admin/notifications",
    supportedLevels: RBAC_LEVELS,
  },
  {
    order: 250,
    section: "Administración",
    code: "ai-models",
    name: "Modelos IA",
    menuRoute: "/admin/system-config/ai",
    supportedLevels: RBAC_LEVELS,
  },
  {
    order: 260,
    section: "Administración",
    code: "ai-costs",
    name: "Costos IA",
    menuRoute: "/admin/cost",
    supportedLevels: RBAC_LEVELS,
  },
  {
    order: 270,
    section: "Administración",
    code: "system-pulse",
    name: "Pulso del sistema",
    menuRoute: "/admin/stability",
    supportedLevels: ["VIEW"],
  },
  {
    order: 280,
    section: "Administración",
    code: "system-status",
    name: "Estado del sistema",
    menuRoute: "/admin/system-status",
    supportedLevels: ["VIEW"],
  },
  {
    order: 290,
    section: "Administración",
    code: "audit",
    name: "Auditoría",
    menuRoute: "/admin/audit",
    supportedLevels: RBAC_LEVELS,
  },
  {
    order: 300,
    section: "Administración",
    code: "compliance",
    name: "Cumplimiento",
    menuRoute: "/admin/compliance-requests",
    supportedLevels: RBAC_LEVELS,
  },
  {
    order: 310,
    section: "Administración",
    code: "architecture",
    name: "Arquitectura",
    menuRoute: "/admin/architecture",
    supportedLevels: ["VIEW"],
  },
  {
    order: 320,
    section: "Administración",
    code: "system-config",
    name: "Configuración",
    menuRoute: "/admin/system-config",
    supportedLevels: RBAC_LEVELS,
  },
] as const satisfies readonly RbacModuleDefinition[];

export type RbacModuleCode = (typeof RBAC_MODULE_CATALOG)[number]["code"];

export interface ModuleGrant {
  moduleCode: string;
  level: RbacLevel;
}

const LEVEL_ORDER: Record<RbacLevel, number> = {
  VIEW: 1,
  INTERACT: 2,
  DELETE: 3,
};

const MODULE_PREFIXES: readonly [string, string][] = [
  ["worklist.", "tasks"],
  ["project.task.", "tasks"],
  ["projects.task.", "tasks"],
  ["tasks.", "tasks"],
  ["project.matter.", "matters"],
  ["project.company.", "matters"],
  ["project.team.", "matters"],
  ["project.timeline.", "matters"],
  ["project.metrics.", "matters"],
  ["project.archive.", "matters"],
  ["projects.", "matters"],
  ["matters.", "matters"],
  ["matter.party.", "matters"],
  ["matter.deadline.", "matters"],
  ["matter.conflict.", "matters"],
  ["matter.template.", "matter-templates"],
  ["platform.matter-type.", "matter-types"],
  ["platform.counterparty.", "counterparties"],
  ["document.", "documents"],
  ["documents.", "documents"],
  ["template.", "templates"],
  ["templates.", "templates"],
  ["clauses.", "templates"],
  ["signature.", "signature"],
  ["workflow.task.", "workflow-inbox"],
  ["workflows.task.", "workflow-inbox"],
  ["workflow.", "workflows"],
  ["workflows.", "workflows"],
  ["ai.chat.", "ai-assistant"],
  ["ai.threads.", "ai-assistant"],
  ["ai.analysis.", "ai-assistant"],
  ["ai.document.", "ai-assistant"],
  ["ai.clause.", "ai-assistant"],
  ["platform.ai.chat.", "ai-assistant"],
  ["orchestrator.conversation.", "ai-assistant"],
  ["rag.", "knowledge-base"],
  ["reports.", "reports"],
  ["report.", "reports"],
  ["risk.category.", "risk-categories"],
  ["risk.scoring.", "risk-scoring"],
  ["risk.", "risks"],
  ["risks.", "risks"],
  ["playbook.compare.", "risks"],
  ["notification.templates.", "email-templates"],
  ["notification.admin.", "system-notifications"],
  ["notification.catalog.", "system-notifications"],
  ["notification.retry.", "system-notifications"],
  ["notification.resend", "system-notifications"],
  ["notification.cancel", "system-notifications"],
  ["notification.", "notifications"],
  ["notifications.", "notifications"],
  ["users.", "users-roles"],
  ["roles.", "users-roles"],
  ["permissions.", "users-roles"],
  ["access-groups.", "users-roles"],
  ["tenant.", "organizations"],
  ["tenants.", "organizations"],
  ["platform.matter-type.", "matter-types"],
  ["system.aiconfig.", "ai-models"],
  ["system.aibudget.", "ai-models"],
  ["ai.config.", "ai-models"],
  ["ai.model.", "ai-models"],
  ["ai.budget.", "ai-models"],
  ["cost.", "ai-costs"],
  ["platform.cost.", "ai-costs"],
  ["stability.", "system-pulse"],
  ["system.status.", "system-status"],
  ["audit.", "audit"],
  ["compliance.", "compliance"],
  ["system.config.", "system-config"],
  ["maintenance.", "system-config"],
  ["client.", "clients"],
];

const DIRECT_MODULES: Record<string, string> = {
  "playbook.read": "templates",
  "playbook.admin": "templates",
  "report.dashboard.view": "panels",
  "reports.kpi.view": "panels",
  "cost.dashboard.view": "panels",
};

const DELETE_TOKENS = new Set([
  "delete",
  "archive",
  "cancel",
  "discard",
  "remove",
  "close",
]);

const INTERACT_TOKENS = new Set([
  "create",
  "update",
  "write",
  "manage",
  "grant",
  "revoke",
  "unlock",
  "run",
  "execute",
  "deploy",
  "claim",
  "complete",
  "sign",
  "resolve",
  "refresh",
  "handle",
  "verify",
  "use",
  "classify",
  "override",
  "upload",
  "publish",
  "decide",
  "request",
  "activate",
  "submit",
  "reassign",
  "retry",
  "start",
  "respond",
  "approve",
  "invite",
  "interact",
  "admin",
]);

const VIEW_TOKENS = new Set([
  "view",
  "list",
  "read",
  "download",
  "export",
  "metrics",
  "dashboard",
  "status",
]);

export function levelIncludes(
  granted: RbacLevel | undefined,
  requested: RbacLevel,
) {
  return Boolean(granted && LEVEL_ORDER[granted] >= LEVEL_ORDER[requested]);
}

export function maxRbacLevel(current: RbacLevel | undefined, next: RbacLevel) {
  if (!current) return next;
  return LEVEL_ORDER[next] > LEVEL_ORDER[current] ? next : current;
}

export function derivePermissionModule(code: string, fallbackModule?: string) {
  if (code.startsWith("module.")) {
    const [, moduleCode] = code.split(".");
    if (moduleCode) return moduleCode;
  }
  const direct = DIRECT_MODULES[code];
  if (direct) return direct;
  const match = MODULE_PREFIXES.find(([prefix]) => code.startsWith(prefix));
  if (match) return match[1];
  if (fallbackModule) return fallbackModule;
  return "system-config";
}

export function derivePermissionLevel(code: string): RbacLevel {
  const tokens = code.split(/[.:_-]/).filter(Boolean);
  if (tokens.some((token) => DELETE_TOKENS.has(token))) return "DELETE";
  if (tokens.some((token) => INTERACT_TOKENS.has(token))) return "INTERACT";
  if (tokens.some((token) => VIEW_TOKENS.has(token))) return "VIEW";
  return "VIEW";
}

export function deriveModuleGrantsFromPermissions(
  permissions: readonly string[],
): ModuleGrant[] {
  const grants = new Map<string, RbacLevel>();
  permissions.forEach((permission) => {
    const moduleCode = derivePermissionModule(permission);
    const level = derivePermissionLevel(permission);
    grants.set(moduleCode, maxRbacLevel(grants.get(moduleCode), level));
  });
  return [...grants.entries()]
    .map(([moduleCode, level]) => ({ moduleCode, level }))
    .sort((a, b) => {
      const orderA =
        RBAC_MODULE_CATALOG.find((module) => module.code === a.moduleCode)
          ?.order ?? Number.MAX_SAFE_INTEGER;
      const orderB =
        RBAC_MODULE_CATALOG.find((module) => module.code === b.moduleCode)
          ?.order ?? Number.MAX_SAFE_INTEGER;
      return orderA - orderB || a.moduleCode.localeCompare(b.moduleCode);
    });
}

export function hasModuleLevelFromPermissions(
  permissions: readonly string[],
  moduleCode: string,
  requested: RbacLevel,
) {
  const granted = deriveModuleGrantsFromPermissions(permissions).find(
    (grant) => grant.moduleCode === moduleCode,
  );
  return levelIncludes(granted?.level, requested);
}
